import cn from 'classnames'

import { DiscountCheckpointProps } from '../../loyalty-program.props'

import styles from './styles.module.scss'

const DiscountCheckpoint = ({
  isChecked = false,
  onMouseEnter,
  onMouseLeave,
  className,
  children,
  style,
}: DiscountCheckpointProps) => {
  return (
    <div
      style={style}
      className={cn(
        styles.checkpoint,
        {
          [styles.checked]: isChecked,
        },
        className,
      )}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      {children}
    </div>
  )
}

export default DiscountCheckpoint
